<template>
  <component
    :is="tag"
    class="hc-button"
    :class="`hc-button--${variant}`"
    :to="to"
    :type="tag === 'button' ? type : null"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <slot name="icon" />
    <slot />
  </component>
</template>

<script>
export default {
  name: "HcButton",
  props: {
    variant: { type: String, default: "secondary" },
    type: { type: String, default: "button" },
    to: { type: [String, Object], default: null },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    tag() {
      return this.to ? "router-link" : "button";
    },
  },
};
</script>
